/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import {NxTextLink} from '@sonatype/react-shared-components';
import {ExtJS} from '@sonatype/nexus-ui-plugin';
import UIStrings from '../../constants/UIStrings';
import SystemNotice from '../widgets/SystemStatusAlerts/SystemNotice';
import '../widgets/SystemStatusAlerts/SystemNotices.scss';

const {ORIENTDB_MIGRATION} = UIStrings;

export default function OrientDBMigrationAlert() {
  const isOrientDB = !ExtJS.state().getValue('nexus.datastore.enabled', false);

  if (!isOrientDB) {
    return null;
  }

  // TODO: Provisional URL - update when final documentation is available
  const migrationUrl = 'https://help.sonatype.com/en/instance-migrator.html';

  return (
    <div className="nxrm-system-notices">
      <SystemNotice 
        noticeLevel="error" 
        additionalAlertClassNames="orientdb-migration-banner"
        nonDismissable={true}
      >
        <strong>{ORIENTDB_MIGRATION.TITLE}</strong>
        <br />
        {ORIENTDB_MIGRATION.MESSAGE}{' '}
        <NxTextLink
          external
          data-analytics-id="orientdb-migration-banner-learn-more"
          href={migrationUrl}
        >
          {ORIENTDB_MIGRATION.LINK_TEXT}
        </NxTextLink>
      </SystemNotice>
    </div>
  );
}
